/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddVendorsToQuotationBatchRequest,
  CreateQuotationBatchRequest,
  EntitiesQuotationBatchBatchVendorsResponse,
  EntitiesQuotationBatchDetail,
  EntitiesQuotationBatchListResponse,
  GetBatchVendorsParams,
  ListQuotationBatchesParams,
  UpdateQuotationBatchRequest
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List of quotation batches
 */
export const listQuotationBatches = (
    params?: ListQuotationBatchesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationBatchListResponse>(
      {url: `/api/v3/quotation_batches`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListQuotationBatchesInfiniteQueryKey = (params?: ListQuotationBatchesParams,) => {
    return [
    'infinite', `/api/v3/quotation_batches`, ...(params ? [params] : [])
    ] as const;
    }

export const getListQuotationBatchesQueryKey = (params?: ListQuotationBatchesParams,) => {
    return [
    `/api/v3/quotation_batches`, ...(params ? [params] : [])
    ] as const;
    }


export const useListQuotationBatchesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(params?: ListQuotationBatchesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationBatchesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationBatches>>> = ({ signal }) => listQuotationBatches(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationBatchesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationBatches>>>
export type ListQuotationBatchesInfiniteQueryError = ErrorType<unknown>


export function useListQuotationBatchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationBatchesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationBatches>>,
          TError,
          Awaited<ReturnType<typeof listQuotationBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationBatches>>,
          TError,
          Awaited<ReturnType<typeof listQuotationBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotation batches
 */

export function useListQuotationBatchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationBatchesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List of quotation batches
 */
export const prefetchListQuotationBatchesInfiniteQuery = async <TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListQuotationBatchesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationBatchesInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationBatchesInfinite} query
 */
export const invalidateListQuotationBatchesInfinite = async (
 queryClient: QueryClient, params?: ListQuotationBatchesParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationBatchesInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(params?: ListQuotationBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationBatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationBatches>>> = ({ signal }) => listQuotationBatches(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationBatches>>>
export type ListQuotationBatchesQueryError = ErrorType<unknown>


export function useListQuotationBatches<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationBatchesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationBatches>>,
          TError,
          Awaited<ReturnType<typeof listQuotationBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatches<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuotationBatches>>,
          TError,
          Awaited<ReturnType<typeof listQuotationBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatches<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotation batches
 */

export function useListQuotationBatches<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List of quotation batches
 */
export const prefetchListQuotationBatchesQuery = async <TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListQuotationBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListQuotationBatchesQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListQuotationBatches} query
 */
export const invalidateListQuotationBatches = async (
 queryClient: QueryClient, params?: ListQuotationBatchesParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListQuotationBatchesQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListQuotationBatchesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationBatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationBatches>>> = ({ signal }) => listQuotationBatches(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationBatchesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationBatches>>>
export type ListQuotationBatchesSuspenseQueryError = ErrorType<unknown>


export function useListQuotationBatchesSuspense<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationBatchesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatchesSuspense<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatchesSuspense<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotation batches
 */

export function useListQuotationBatchesSuspense<TData = Awaited<ReturnType<typeof listQuotationBatches>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationBatchesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListQuotationBatchesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuotationBatchesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotationBatches>>> = ({ signal }) => listQuotationBatches(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQuotationBatchesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotationBatches>>>
export type ListQuotationBatchesSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListQuotationBatchesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListQuotationBatchesParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatchesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQuotationBatchesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of quotation batches
 */

export function useListQuotationBatchesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listQuotationBatches>>>, TError = ErrorType<unknown>>(
 params?: ListQuotationBatchesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listQuotationBatches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQuotationBatchesSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a quotation batch
 */
export const createQuotationBatch = (
    createQuotationBatchRequest: CreateQuotationBatchRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationBatchDetail>(
      {url: `/api/v3/quotation_batches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createQuotationBatchRequest, signal
    },
      options);
    }




export const getCreateQuotationBatchMutationKey = () => ['createQuotationBatch'] as const;

export const getCreateQuotationBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuotationBatch>>, TError,CreateQuotationBatchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuotationBatch>>, TError,CreateQuotationBatchMutationVariables, TContext> => {

const mutationKey = getCreateQuotationBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuotationBatch>>, CreateQuotationBatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createQuotationBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateQuotationBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createQuotationBatch>>>
    export type CreateQuotationBatchMutationBody = CreateQuotationBatchRequest
    export type CreateQuotationBatchMutationError = ErrorType<unknown>
    export type CreateQuotationBatchMutationVariables = {data: CreateQuotationBatchRequest}

    /**
 * @summary Create a quotation batch
 */
export const useCreateQuotationBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuotationBatch>>, TError,CreateQuotationBatchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createQuotationBatch>>,
        TError,
        CreateQuotationBatchMutationVariables,
        TContext
      > => {
      return useMutation(getCreateQuotationBatchMutationOptions(options), queryClient);
    }
    /**
 * @summary Get vendor suggestions for batch
 */
export const getBatchVendors = (
    params?: GetBatchVendorsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationBatchBatchVendorsResponse>(
      {url: `/api/v3/quotation_batches/batch_vendors`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetBatchVendorsInfiniteQueryKey = (params?: GetBatchVendorsParams,) => {
    return [
    'infinite', `/api/v3/quotation_batches/batch_vendors`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetBatchVendorsQueryKey = (params?: GetBatchVendorsParams,) => {
    return [
    `/api/v3/quotation_batches/batch_vendors`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetBatchVendorsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(params?: GetBatchVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBatchVendorsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchVendors>>> = ({ signal }) => getBatchVendors(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBatchVendorsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBatchVendors>>>
export type GetBatchVendorsInfiniteQueryError = ErrorType<unknown>


export function useGetBatchVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBatchVendorsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatchVendors>>,
          TError,
          Awaited<ReturnType<typeof getBatchVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatchVendors>>,
          TError,
          Awaited<ReturnType<typeof getBatchVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get vendor suggestions for batch
 */

export function useGetBatchVendorsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBatchVendorsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get vendor suggestions for batch
 */
export const prefetchGetBatchVendorsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: GetBatchVendorsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetBatchVendorsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetBatchVendorsInfinite} query
 */
export const invalidateGetBatchVendorsInfinite = async (
 queryClient: QueryClient, params?: GetBatchVendorsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetBatchVendorsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useGetBatchVendorsQueryOptions = <TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(params?: GetBatchVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBatchVendorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchVendors>>> = ({ signal }) => getBatchVendors(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBatchVendorsQueryResult = NonNullable<Awaited<ReturnType<typeof getBatchVendors>>>
export type GetBatchVendorsQueryError = ErrorType<unknown>


export function useGetBatchVendors<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBatchVendorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatchVendors>>,
          TError,
          Awaited<ReturnType<typeof getBatchVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendors<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatchVendors>>,
          TError,
          Awaited<ReturnType<typeof getBatchVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendors<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get vendor suggestions for batch
 */

export function useGetBatchVendors<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBatchVendorsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get vendor suggestions for batch
 */
export const prefetchGetBatchVendorsQuery = async <TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: GetBatchVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetBatchVendorsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetBatchVendors} query
 */
export const invalidateGetBatchVendors = async (
 queryClient: QueryClient, params?: GetBatchVendorsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetBatchVendorsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useGetBatchVendorsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBatchVendorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchVendors>>> = ({ signal }) => getBatchVendors(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBatchVendorsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBatchVendors>>>
export type GetBatchVendorsSuspenseQueryError = ErrorType<unknown>


export function useGetBatchVendorsSuspense<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBatchVendorsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendorsSuspense<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendorsSuspense<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get vendor suggestions for batch
 */

export function useGetBatchVendorsSuspense<TData = Awaited<ReturnType<typeof getBatchVendors>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBatchVendorsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetBatchVendorsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBatchVendorsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchVendors>>> = ({ signal }) => getBatchVendors(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBatchVendorsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBatchVendors>>>
export type GetBatchVendorsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetBatchVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBatchVendorsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatchVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get vendor suggestions for batch
 */

export function useGetBatchVendorsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBatchVendors>>>, TError = ErrorType<unknown>>(
 params?: GetBatchVendorsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getBatchVendors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBatchVendorsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Show quotation batch
 */
export const showQuotationBatch = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationBatchDetail>(
      {url: `/api/v3/quotation_batches/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowQuotationBatchInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/quotation_batches/${id}`
    ] as const;
    }

export const getShowQuotationBatchQueryKey = (id: number,) => {
    return [
    `/api/v3/quotation_batches/${id}`
    ] as const;
    }


export const useShowQuotationBatchInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationBatchInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotationBatch>>> = ({ signal }) => showQuotationBatch(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationBatchInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotationBatch>>>
export type ShowQuotationBatchInfiniteQueryError = ErrorType<unknown>


export function useShowQuotationBatchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotationBatch>>,
          TError,
          Awaited<ReturnType<typeof showQuotationBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotationBatch>>,
          TError,
          Awaited<ReturnType<typeof showQuotationBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation batch
 */

export function useShowQuotationBatchInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationBatchInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show quotation batch
 */
export const prefetchShowQuotationBatchInfiniteQuery = async <TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowQuotationBatchInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowQuotationBatchInfinite} query
 */
export const invalidateShowQuotationBatchInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowQuotationBatchInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowQuotationBatchQueryOptions = <TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationBatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotationBatch>>> = ({ signal }) => showQuotationBatch(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationBatchQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotationBatch>>>
export type ShowQuotationBatchQueryError = ErrorType<unknown>


export function useShowQuotationBatch<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotationBatch>>,
          TError,
          Awaited<ReturnType<typeof showQuotationBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatch<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showQuotationBatch>>,
          TError,
          Awaited<ReturnType<typeof showQuotationBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatch<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation batch
 */

export function useShowQuotationBatch<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationBatchQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show quotation batch
 */
export const prefetchShowQuotationBatchQuery = async <TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowQuotationBatchQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowQuotationBatch} query
 */
export const invalidateShowQuotationBatch = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowQuotationBatchQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowQuotationBatchSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationBatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotationBatch>>> = ({ signal }) => showQuotationBatch(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationBatchSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotationBatch>>>
export type ShowQuotationBatchSuspenseQueryError = ErrorType<unknown>


export function useShowQuotationBatchSuspense<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatchSuspense<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatchSuspense<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation batch
 */

export function useShowQuotationBatchSuspense<TData = Awaited<ReturnType<typeof showQuotationBatch>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationBatchSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowQuotationBatchSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowQuotationBatchInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showQuotationBatch>>> = ({ signal }) => showQuotationBatch(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowQuotationBatchSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showQuotationBatch>>>
export type ShowQuotationBatchSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowQuotationBatchSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatchSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowQuotationBatchSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show quotation batch
 */

export function useShowQuotationBatchSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showQuotationBatch>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showQuotationBatch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowQuotationBatchSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update quotation batch
 */
export const updateQuotationBatch = (
    id: number,
    updateQuotationBatchRequest?: UpdateQuotationBatchRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationBatchDetail>(
      {url: `/api/v3/quotation_batches/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateQuotationBatchRequest, signal
    },
      options);
    }




export const getUpdateQuotationBatchMutationKey = () => ['updateQuotationBatch'] as const;

export const getUpdateQuotationBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuotationBatch>>, TError,UpdateQuotationBatchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateQuotationBatch>>, TError,UpdateQuotationBatchMutationVariables, TContext> => {

const mutationKey = getUpdateQuotationBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateQuotationBatch>>, UpdateQuotationBatchMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateQuotationBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateQuotationBatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuotationBatch>>>
    export type UpdateQuotationBatchMutationBody = UpdateQuotationBatchRequest | undefined
    export type UpdateQuotationBatchMutationError = ErrorType<unknown>
    export type UpdateQuotationBatchMutationVariables = {id: number;data?: UpdateQuotationBatchRequest}

    /**
 * @summary Update quotation batch
 */
export const useUpdateQuotationBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuotationBatch>>, TError,UpdateQuotationBatchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateQuotationBatch>>,
        TError,
        UpdateQuotationBatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateQuotationBatchMutationOptions(options), queryClient);
    }
    /**
 * @summary Add vendors to a quotation batch
 */
export const addVendorsToQuotationBatch = (
    id: number,
    addVendorsToQuotationBatchRequest: AddVendorsToQuotationBatchRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesQuotationBatchDetail>(
      {url: `/api/v3/quotation_batches/${id}/add_vendor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addVendorsToQuotationBatchRequest, signal
    },
      options);
    }




export const getAddVendorsToQuotationBatchMutationKey = () => ['addVendorsToQuotationBatch'] as const;

export const getAddVendorsToQuotationBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addVendorsToQuotationBatch>>, TError,AddVendorsToQuotationBatchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addVendorsToQuotationBatch>>, TError,AddVendorsToQuotationBatchMutationVariables, TContext> => {

const mutationKey = getAddVendorsToQuotationBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addVendorsToQuotationBatch>>, AddVendorsToQuotationBatchMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addVendorsToQuotationBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddVendorsToQuotationBatchMutationResult = NonNullable<Awaited<ReturnType<typeof addVendorsToQuotationBatch>>>
    export type AddVendorsToQuotationBatchMutationBody = AddVendorsToQuotationBatchRequest
    export type AddVendorsToQuotationBatchMutationError = ErrorType<unknown>
    export type AddVendorsToQuotationBatchMutationVariables = {id: number;data: AddVendorsToQuotationBatchRequest}

    /**
 * @summary Add vendors to a quotation batch
 */
export const useAddVendorsToQuotationBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addVendorsToQuotationBatch>>, TError,AddVendorsToQuotationBatchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addVendorsToQuotationBatch>>,
        TError,
        AddVendorsToQuotationBatchMutationVariables,
        TContext
      > => {
      return useMutation(getAddVendorsToQuotationBatchMutationOptions(options), queryClient);
    }
